"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNotificationDetails = void 0;
const frontend_infra_localisation_1 = require("@forto-dev/frontend-infra-localisation");
const frontend_infra_reactquery_1 = require("@forto-dev/frontend-infra-reactquery");
const frontend_infra_snack_1 = require("@forto-dev/frontend-infra-snack");
const notification_center_models_1 = require("@forto-dev/notification-center-models");
const translations_1 = require("../types/translations");
const updateNotificationStatus_1 = require("./updateNotificationStatus");
const useFetchNotificationDetails_1 = require("./useFetchNotificationDetails");
const useNotificationDetails = ({ notificationID, status }) => {
    const snackService = (0, frontend_infra_snack_1.useSnackService)();
    const { current } = (0, frontend_infra_localisation_1.useI18n)();
    const { translate } = (0, frontend_infra_localisation_1.useI18n)();
    const updateNotifications = (0, updateNotificationStatus_1.useUpdateNotificationStatus)();
    const fetchNotificationDetails = (0, useFetchNotificationDetails_1.useFetchNotificationDetails)(notificationID);
    const notificationDetailsResult = (0, frontend_infra_reactquery_1.useQuery)({
        queryKey: ['notificationDetails', notificationID, current],
        queryFn: async () => {
            try {
                const response = await fetchNotificationDetails();
                if (status === 'unread') {
                    updateNotifications.mutate({ ids: [notificationID], status: notification_center_models_1.UserNotificationStatus.Read });
                }
                return response;
            }
            catch (e) {
                snackService.showError(translate(translations_1.notificationDetailTranslations.loadError));
                return Promise.reject(e);
            }
        },
        placeholderData: frontend_infra_reactquery_1.keepPreviousData,
    });
    return notificationDetailsResult;
};
exports.useNotificationDetails = useNotificationDetails;
//# sourceMappingURL=getNotificationDetails.js.map